import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';

import {accountDatasetEntitlementsStateSelector} from './account-dataset-entitlements-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {EntitlementsFilters, ResourceView} from 'src/modules/entitlements/typedef';

export const accountDatasetEntitlementsSlice = getCachedTableDataSlice<
    ResourceView[],
    undefined,
    undefined,
    EntitlementsFilters
>('accountDatasetEntitlements');

export const accountDatasetEntitlementsActions = accountDatasetEntitlementsSlice.actions;
const accountDatasetEntitlementsCacheSelector: CachedTableCacheSelector<ResourceView[]>
    = state => state.accountPage.tabs.datasetEntitlements.entitlements.cache;
export const accountDatasetEntitlementsDataSelector: CachedTableDataSelector<ResourceView[]>
    = state => state.accountPage.tabs.datasetEntitlements.entitlements;
export const accountDatasetEntitlementsResultSelector = getCachedTableResultSelector(
    accountDatasetEntitlementsCacheSelector,
    accountDatasetEntitlementsStateSelector,
);
